import { ArrowRightOutlined } from "@ant-design/icons";
import {
  Form,
  DatePicker,
  Input,
  Row,
  Col,
  Typography,
  Space,
  FormProps,
  Button,
} from "antd";
import { formatDate } from "../components/constants";
import { onlyLatinCharsDigitsSpecialSymbolsRule } from "../../utils/form.constants";

interface TableFormProps extends FormProps {
  onSubmit?: VoidFunction;
  showDateFilter?: boolean;
  searchPlaceholder?: string;
}

export const TableForm = ({
  onSubmit,
  showDateFilter = true,
  searchPlaceholder,
  ...formProps
}: TableFormProps) => (
  <Form
    {...formProps}
    layout="vertical"
    style={{
      background: "#FAFAFA",
      borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
      padding: "16px 10px  0",
    }}
  >
    <Row justify="space-between">
      <Col lg={8} md={10}>
        <Space.Compact style={{ width: "100%" }}>
          <Form.Item
            name="searchValue"
            style={{ width: "100%" }}
            rules={[onlyLatinCharsDigitsSpecialSymbolsRule]}
          >
            <Input
              placeholder={searchPlaceholder ?? "Search by name"}
              allowClear
              onChange={(e) => !e.currentTarget.value && onSubmit && onSubmit()}
            />
          </Form.Item>
          <Button
            type="primary"
            style={{ borderRadius: "0px 6px 6px 0px", marginTop: "5px" }}
            onClick={onSubmit}
          >
            Search
          </Button>
        </Space.Compact>
      </Col>
      {showDateFilter && (
        <Col
          lg={16}
          md={14}
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "flex-end",
            marginTop: "-5px",
          }}
        >
          <Typography.Text
            style={{
              fontSize: 14,
              color: "rgba(0, 0, 0, 0.45)",
              marginRight: 12,
            }}
          >
            Search by creation date
          </Typography.Text>
          <Form.Item name="createdAt" style={{ margin: 0 }}>
            <DatePicker.RangePicker
              allowClear
              onChange={onSubmit}
              format={formatDate}
              separator={<ArrowRightOutlined style={{ color: "#c2c2c2" }} />}
            />
          </Form.Item>
        </Col>
      )}
    </Row>
  </Form>
);
